import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreateContactPopup.PurchaseAndSalesSettingsSection', {
    salesSettingsHeader: 'Sales settings',
    salesAccountLabel: 'Default account',
    dropdownPlaceholder: 'Select option',
    purchaseSettingsHeader: 'Purchase settings',
    purchaseAccountLabel: 'Default account',
});
